import { CalendarEvent, CalendarEventResponse, CalendarEventResponseResponse, User } from "../../../Utilities";

export type Base = {
	response: CalendarEventResponse["response"] | null;
	calendarEventID: CalendarEvent["id"] | null;
};

export type Create = Base;

export type CreateRequiredKey = Extract<keyof Create, "response" | "calendarEventID">;

export type CreateSubset<K extends keyof Create = keyof Create> = Pick<Create, CreateRequiredKey | K>;

export const initialCreate: Create = {
	response: null,
	calendarEventID: null,
};

export type Detail = Base & {
	authorID: User["id"] | null;
};

export type DetailSubset<K extends keyof Detail = keyof Detail> = Pick<Detail, K>;

// Custom labels

export const responseOptions = [
	{ value: CalendarEventResponseResponse.Attending, label: "Going" },
	{ value: CalendarEventResponseResponse.MaybeAttending, label: "Maybe" },
	{ value: CalendarEventResponseResponse.NotAttending, label: "Not Going" },
];
